module.exports = __webpack_public_path__ + "img/full7-min.39d33bf0.png";